export const MarketPriceEstimationData = [
  {
    value: 'H',
    label: '추정 정확도 높음',
  },
  {
    value: 'M',
    label: '추정 정확도 보통',
  },
];

export const AppraisalPointData = [
  {
    value: 'B',
    label: '6개월 이내',
  },
  {
    value: 'C',
    label: '6~12개월',
  },
  {
    value: 'D',
    label: '12개월 이상',
  },
];

export const NumberOfFailedBidData = [
  {
    value: '0',
    label: '신건',
  },
  {
    value: '1',
    label: '1회 이하',
  },
  {
    value: '2',
    label: '2회 이하',
  },
  {
    value: '3',
    label: '3회 이하',
  },
  {
    value: '4',
    label: '4회 이하',
  },
  {
    value: '5',
    label: '5회 이상',
  },
];

export const OldAgeData = [
  {
    value: 'B',
    label: '5년 이내',
  },
  {
    value: 'C',
    label: '5~10년',
  },
  {
    value: 'D',
    label: '10~15년',
  },
  {
    value: 'E',
    label: '15~20년',
  },
  {
    value: 'F',
    label: '20~30년',
  },
  {
    value: 'G',
    label: '30년 이상',
  },
];

export const SalesDaysData = [
  {
    value: 'B',
    label: '3개월 이내',
  },
  {
    value: 'C',
    label: '6개월 이내',
  },
  {
    value: 'D',
    label: '12개월 이내',
  },
  {
    value: 'E',
    label: '12개월 이상',
  },
];

export const RealReturnData = [
  {
    value: '~10% 수익',
    label: '~10% 수익',
  },
  {
    value: '10~30% 수익',
    label: '10~30% 수익',
  },
  {
    value: '30~50% 수익',
    label: '30~50% 수익',
  },
  {
    value: '50~100% 수익',
    label: '50~100% 수익',
  },
  {
    value: '100% 이상 수익',
    label: '100% 이상 수익',
  },
];
